// https://atlassian-2y.sentry.io/projects/afm-search-ai/getting-started/
export const SENTRY_DSN =
	'https://467ed23c400f1de490da05364bed5930@o55978.ingest.us.sentry.io/4507432686125056';

export const UNKNOWN_TAG = 'unknown';
